module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-medium.woff
// module id = Y0CM
// module chunks = 0